import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Grid, LinearProgress, Paper, Typography } from '@mui/material';
import userLogout from 'redux/actions/userLogout';
import isLoggedIn from 'global/utils/isLoggedIn';
import useStyles from './UserLogout.styles';

export default function Logout() {
  const loggedIn = useSelector((state) => isLoggedIn(state.auth));
  const dispatch = useDispatch();
  const classes = useStyles();

  const renderRedirect = (redirect) => {
    if (!redirect) {
      return <Redirect to="/" />;
    }
  };

  useEffect(() => {
    if (loggedIn === true) {
      dispatch(userLogout());
    }
  }, []);

  return (
    <Grid justifyContent="center" alignItems="center" container className={classes.logoutGrid}>
      <Grid item className={classes.gridItem} xs={10} lg={6}>
        <Paper className={classes.loadingPaper}>
          {renderRedirect(loggedIn)}
          <Typography component="h1" variant="h5">
            Bye Bye!
          </Typography>
          <LinearProgress color="secondary" className={classes.loadingPaperProgress} />
          <Typography variant="subtitle1">Hang on, we're erasing your footsteps and sweeping away the breadcrumbs.</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
}
